import Image from 'next/image'
import React from 'react'
import { BaseCard } from '../BaseCard'
import { DiscountHeader } from '../DiscountHeader'
import { MerchCardProps } from '../index'
import { FeaturedMerchCard } from './FeaturedMerchCard'

// import { toBase64, shimmer } from 'src/common/utils'

export const MerchCard = ({
    imageURL,
    title,
    price,
    subtitle = null,
    // rating = 0,
    selected = null,
    isFavorited = null,
    featured = false,
    percentOff = 0,
    href,
    onClick,
    isSoldOut = false
}: MerchCardProps) => {
    if (featured) {
        return (
            <FeaturedMerchCard
                imageURL={imageURL}
                key={imageURL}
                title={title}
                price={price}
                isFavorited={isFavorited}
                percentOff={percentOff}
                href={href}
            />
        )
    }

    return (
        <BaseCard
            onClick={isSoldOut ? () => null : onClick}
            isMerchCard
            href={href}
            cardType="narrow"
            boxShadow
        >
            <div
                className={`flex max-h-[180px] justify-center ${
                    isSoldOut ? 'opacity-50' : ''
                }`}
            >
                <DiscountHeader percent={percentOff} />
                <div className="relative">
                    <Image
                        alt={`${title} card image`}
                        src={imageURL}
                        className="rounded-xl"
                        objectFit="contain"
                        objectPosition="center"
                        width="200px"
                        height="180px"
                        key={`merch-${imageURL}`}
                        // placeholder="blur"
                        // blurDataURL={`data:image/svg+xml;base64,${toBase64(
                        //     shimmer(225, 300)
                        // )}`}
                    />

                    {/* <img
                        loading="lazy"
                        alt={`${title} card image`}
                        src={imageURL}
                        className="object-cover w-[200px] h-[180px] object-center rounded-xl"
                    /> */}

                    {selected && (
                        <div className="absolute top-0 left-0 right-0 bottom-0 bg-yf-green bg-opacity-70 flex items-center justify-center rounded-xl max-h-[180px]">
                            <i className="fak fa-yf-checked text-7xl text-white"></i>
                        </div>
                    )}
                    {/* // TODO: liked status  */}
                </div>
            </div>

            <div className="flex flex-col justify-items-end px-2 text-left">
                <p className="mt-6 text-lg text-gray-900 line-clamp-2 leading-5">
                    {title}
                </p>

                {subtitle && <p className="mt-1 text-sm text-yf-green">{subtitle}</p>}

                {isSoldOut ? (
                    <p className="text-lg font-medium text-red-500">SOLD OUT</p>
                ) : (
                    <p className="mb-2.5 text-lg text-yf-green font-normal absolute bottom-1 left-5">
                        {price}
                    </p>
                )}

                {/* TODO: rating */}
            </div>
        </BaseCard>
    )
}
